import FreeText from '@algbra/ui/components/FreeText/FreeText'
import Heading from '@algbra/ui/components/Heading/Heading'
import { GatsbyImage } from 'gatsby-plugin-image'
import { EventEntity } from '../../types/event'
import { resolveAsImage } from '@algbra/ui/resolvers'
import styles from './MeetupItem.module.scss'

export type MeetupItemProps = {
  event: EventEntity
}

export default function MeetupItem(props: MeetupItemProps) {
  const { event } = props
  const { title, summary, image, link, date, location } = event
  return (
    <div
      className={styles.container}
      itemScope
      itemType="http://schema.org/Event"
    >
      <a className={styles.event} href={link} target="_new">
        <div className={styles.image}>
          {image && (
            <GatsbyImage
              image={resolveAsImage(image)}
              alt={`Algbra Event: ${title}`}
              itemProp="photo"
            />
          )}
        </div>
        <div className={styles.content}>
          <Heading level={3} type="sm" className={styles.title} itemProp="name">
            {title}
          </Heading>
          <FreeText color="secondary" innerHTML={summary}>
            {summary}
          </FreeText>
          {date && (
            <span className={styles.hidden} itemProp="startDate">
              {date}
            </span>
          )}
          {location && (
            <span className={styles.hidden} itemProp="location">
              {location}
            </span>
          )}
        </div>
      </a>
    </div>
  )
}
